<template>
  <el-dialog
    title="修改任务名称"
    :visible.sync="dialogFormVisible"
    width="550px"
    :before-close="close"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <el-form-item label="任务名称" prop="name" label-width="120px">
        <el-input v-model="initForm.name"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Flags } from "@/components/Index/data.js";
export default {
  props: {
    initForm: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }]
      },
      Flags: Flags
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        let methods = "patch";
        let url = "tasks/" + this.initForm.id + "/";
        this.$http[methods](url, { name: this.initForm.name }, () => {
          this.$baseNotice.message("编辑成功");
          this.$emit("close");
          this.$emit("update");
        });
      });
    }
  }
};
</script>
